export const WEB_URL = process.env.REACT_APP_WEB_URL ?? 'https://properti1.com';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const IMAGER_URL = process.env.REACT_APP_IMAGER_URL;
export const IMAGE_BASE_PATH = process.env.REACT_APP_IMAGE_BASE_PATH;
